import axios from "@/config/axiosConfig";
import { CREATE_DRAFT_DEBIT_NOTE_BILL_BASE, GET_DRAFT_DEBIT_NOTE_BILL_BASES, DRAFT_DEBIT_NOTE_BILL_BASE_REQUEST, UPDATE_DRAFT_DEBIT_NOTE_BILL_BASE, DELETE_DRAFT_DEBIT_NOTE_BILL_BASE,
  DRAFT_DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, DRAFT_DEBIT_NOTE_BILL_BASE_REQUEST_SUCCESS, 
  GET_DRAFT_DEBIT_NOTES_BILL_BASES_PAGE} from "../types";
import { Entry_Type } from '@/utils';

export const getDraftDebitNoteBillBaseWithPagination = (page, limit, include, searchStr, searchCols, where, addTotal) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DRAFT_DEBIT_NOTE_BILL_BASE_REQUEST });
      
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id, companyId: auth.company?.id,
        page, limit, include, addTotal, search: searchStr, searchCols, where,
        includeAttr: 'Account_Id,Credit_Account_Id,Item_Id'
      };
      return axios.get("/draft-debit-note-bill-base/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_DRAFT_DEBIT_NOTES_BILL_BASES_PAGE, payload: { ...response.data, where } });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DRAFT_DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DRAFT_DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getDraftDebitNoteBillBases = (include, searchStr, searchCols, limit) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DRAFT_DEBIT_NOTE_BILL_BASE_REQUEST });
      const { auth } = getState();
      let params = { finyearId: auth.finyear?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, include, search: searchStr, searchCols, limit };
      }
      return axios.get("/draft-debit-note-bill-base/get", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: GET_DRAFT_DEBIT_NOTE_BILL_BASES, payload: response.data?.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DRAFT_DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DRAFT_DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getValidatedIncrementedVchNoDraftDebitNoteBillBase = (currentVchNo) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id
      };
      
      const response = await axios.get("/draft-debit-note-bill-base/get-next-vch-no", { params });
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getDraftDebitNoteBillBaseByRange = (billId, from, to) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        billId, from, to
      };
      
      const response = await axios.get("/draft-debit-note-bill-base/getAll", { params });
      return response.data;

    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};

export const getDraftDebitNoteBillBaseById = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DRAFT_DEBIT_NOTE_BILL_BASE_REQUEST });
    
      return axios.get(`/draft-debit-note-bill-base/get/${id}`).then((response) => {
        dispatch({ type: DRAFT_DEBIT_NOTE_BILL_BASE_REQUEST_SUCCESS });
        return response?.data;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DRAFT_DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DRAFT_DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const createDraftDebitNoteBillBase = (draftDebitNoteBillBase) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      dispatch({ type: DRAFT_DEBIT_NOTE_BILL_BASE_REQUEST });
      const newDraftDebitNoteBillBase = {
        ...draftDebitNoteBillBase
      };
      return axios.post("/draft-debit-note-bill-base/add", newDraftDebitNoteBillBase,
        { params: { userId: auth.user?.id, companyId: auth.company?.id, finyearId: auth.finyear?.id, customerId: auth?.user?.Customer_Id } }
      ).then((response) => {
        if (response.data) {
          dispatch({ type: CREATE_DRAFT_DEBIT_NOTE_BILL_BASE, payload: response.data });
        } else {
          dispatch({
            type: DRAFT_DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE,
            error: "Draft Debit Note Bill Base create failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DRAFT_DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
        throw error; 
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DRAFT_DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const updateDraftDebitNoteBillBase = (id, data) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DRAFT_DEBIT_NOTE_BILL_BASE_REQUEST });
      const { auth } = getState();
      return axios.put("/draft-debit-note-bill-base/update", { id, data },
        { params: { 
            userId: auth.user?.id,
            companyId: data.Company_Id || auth.company?.id,
            finyearId: data.Finyear_Id || auth.finyear?.id,
            customerId: data.Customer_Id || auth?.user?.Customer_Id,
          }
        }
      ).then((response) => {
        if (response.data) {
          dispatch({
            type: UPDATE_DRAFT_DEBIT_NOTE_BILL_BASE,
            payload: { id, data: response.data },
          });
        } else {
          dispatch({
            type: DRAFT_DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE,
            error: "Draft Debit Note Bill Base update failed.",
          });
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DRAFT_DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DRAFT_DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const deleteDraftDebitNoteBillBase = (id) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DRAFT_DEBIT_NOTE_BILL_BASE_REQUEST });
      const { auth } = getState();
      return axios.delete(`/draft-debit-note-bill-base/delete/${id}`, { params: { userId: auth.user?.id }}).then((response) => {
        if (response.data) {
          dispatch({ type: DELETE_DRAFT_DEBIT_NOTE_BILL_BASE, id: id });
          const include = ['id', 'Vch_No', 'Date', 'Account_Id', 'Credit_Account_Id', 'Invoice_No', 'Invoice_Date', 'Amount', 'Total_Amount'].join(',');
          const searchCols = ['Vch_No'].join(',');
          const { draft: { draftDebitNoteBillBase: { page, pageSize, search, where } = {} } } = getState();
          dispatch(getDraftDebitNoteBillBaseWithPagination(page, pageSize, include, search, searchCols, where, true));
        }
        return response;
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DRAFT_DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
        throw error;
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DRAFT_DEBIT_NOTE_BILL_BASE_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const getAllSalesBillByInvoiceNoInDraftDebitNoteBillBase = (invNo) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      let params = {
        companyId: auth.company?.id,
        customerId: auth?.user?.Customer_Id,
        invoiceNo: invNo,
      };
      return axios.get(`/draft-debit-note-bill-base/get-all-sales-bill-by-invoice-no`, { params }).then((response) => {
        return response?.data;
      }).catch((error) => {
        console.error(error); 
      });
    } catch (error) {
      console.error(error);
    }
  };
};

export const getPaymentDetailsByDraftDebitNoteBillBaseId = (id) => {
  return async (dispatch, getState) => {
    try {
      const params = {
        billId: id,
        billType: Entry_Type.DRAFT_DEBIT_NOTE_BILL_BASE
      };
      return axios.get(`/bill-adjustment/get-payment-detail-by-id`, { params })
        .then((response) => {
          return response?.data;
        }).catch((error) => {
          console.error(error);
          throw error;
        });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};